$(document).on('ready', function () {
    /* Проверка на наличие аддишина ниже! Если он есть, то добавить стрелочку якоря(ВНИЗ). Скрипт клика описан ниже ('.anchor_to_bottom_addition') ==============================================================================================*/
    var additionFirst = $('.addition_data').eq(0),
        additionNext = additionFirst.next('.addition_data'),
        additionAnchor = additionFirst.find('.anchor_to_bottom_addition');
    if (additionNext.length != 0) {
        additionAnchor.addClass('visibility');
    } else {
        additionAnchor.removeClass('visibility');
    }
    /* END Проверка на наличие аддишина ниже! Если он есть, то добавить стрелочку якоря(ВНИЗ). Скрипт клика описан ниже ('.anchor_to_bottom_addition') ==============================================================================================*/
});
$(document).on('ready', function () {
    var flexParent = $('.addition_motorrad_spoilers_slides_collection');
    flexParent.each(function () {
        if ($(this).find('.flex__children').length != 0) {
            $(this).addClass('flex__parent');
            // $(this).parents('.container__min').addClass('container').removeClass('container__min');
        } else {
            $(this).removeClass('flex__parent');
            // $(this).parents('.container').addClass('container__min').removeClass('container');
        }
    })
    /*= Добавление в дата-атрибут для всех блоков с инфой их начальной - минимальной высоты для клика, который описан выше ('.wall__link') =============================================================================================*/
    var infos = $('.wall__info');
    infos.each(function () {
        var infos = $(this),
            infosX = infos.offset().top,
            infosParent = infos.parents('.wall__link.js_click');
        if (infosParent.length != 0) {
            infosParentH = infosParent.outerHeight(true),
                infosParentX = infosParent.offset().top,
                infosMinTop = infosX - infosParentX;
            infos.attr('data-min_top', infosMinTop);
        }
    })
    /*= END Добавление в дата-атрибут для всех блоков с инфой их начальной - минимальной высоты для клика, который описан выше ('.wall__link') =============================================================================================*/
})
/*= клик на блок wall на главной странице - вывод units, определение мин-высоты описано ниже (infos.each) =====================================================================================================================================================*/
$(document).on('click', '.wall__link.js_click', function () {
    var link = $(this),
        links = $('.wall__link.js_click'),
        info = link.find('.wall__info'),
        infoMinTop = info.attr('data-min_top'),
        desc = link.find('.wall__desc_holder'),
        descs = $('.wall__desc_holder'),
        infos = $('.wall__info'),
        infosParents = infos.parents('.wall__link.js_click');
    if (!link.hasClass('is_active')) {
        links.removeClass('is_active').addClass('no_active');
        link.addClass('is_active').removeClass('no_active');
        infos.each(function () {
            var infos = $(this),
                infosMinTop = infos.attr('data-min_top');
            if (infosParents.hasClass('no_active')) {
                infos.stop().animate({
                    'top': infosMinTop
                }, 100, function () {
                    infos.removeAttr('style');
                })
            }
        })
        if (link.parents('.wall__item').hasClass('wall__item--50')) {
            info.stop().animate({
                'top': 0
            }, 100)
        } else if (link.parents('.wall__item').hasClass('wall__item--75')) {
            info.stop().animate({
                'top': 0
            }, 100)
        } else if (link.parents('.wall__item').hasClass('wall__item--25')) {
            info.stop().animate({
                'top': '12%'
            }, 100)
        } else if (link.parents('.wall__item').hasClass('wall__item--100')) {
            if (window.innerWidth < 1024) {
                // console.log('< 1024');
                info.stop().animate({
                    'top': '0'
                }, 100)
            } else {
                // console.log('>= 1024');
            }
        }
        descs.stop().slideUp(300, function () {
            desc.removeAttr('style')
        });
        setTimeout(function () {
            desc.stop().slideDown(300);
        }, 300)
    } else {
        link.removeClass('is_active');
        info.animate({
            'top': infoMinTop
        }, 100, function () {
            info.removeAttr('style')
        })
        desc.stop().slideUp(300, function () {
            desc.removeAttr('style')
        });
    }
})
/*= END клик на блок wall на главной странице - вывод units, определение мин-высоты описано ниже (infos.each) =====================================================================================================================================================*/


$(window).on('load resize', function () {
    if (window.innerWidth > 1023) {
        /* Проверка центрального заголовка на размер, если не помещается, то уменьшаем шрифт ==============================================================================================*/
        var centerCaprion = $('.addition_center_caption_title');
        centerCaprion.each(function () {
            var centerCaprion = $(this),
                centerCaprionW = centerCaprion.width(),
                centerCaprionF = parseInt(centerCaprion.css('font-size')),
                centerCaprionP = centerCaprion.parents('.addition_center_caption'),
                centerCaprionPW = centerCaprionP.width(),
                difference = centerCaprionPW / centerCaprionW,
                fontSize = Math.round(centerCaprionF * difference);
            if (fontSize <= 78) {
                centerCaprion.css({
                    'font-size': Math.round(centerCaprionF * difference),
                    'line-height': Math.round(centerCaprionF * difference) + 'px'
                })
            } else {
                centerCaprion.removeAttr('style');
            }
        })
        var centerCaprionText = $('.addition_center_caption_text');
        centerCaprionText.each(function () {
            var centerCaprionText = $(this),
                centerCaprionTextW = centerCaprionText.width(),
                centerCaprionTextF = parseInt(centerCaprionText.css('font-size')),
                centerCaprionTextP = centerCaprionText.parents('.addition_center_caption'),
                centerCaprionTextPW = centerCaprionTextP.width(),
                differenceText = centerCaprionTextPW / centerCaprionTextW,
                fontSizeText = Math.round(centerCaprionTextF * differenceText);
            if (fontSizeText <= 38) {
                centerCaprionText.css({
                    'font-size': Math.round(centerCaprionTextF * differenceText),
                    'line-height': Math.round(centerCaprionTextF * differenceText) + 'px'
                })
            } else {
                centerCaprionText.removeAttr('style');
            }
        })
        /* END Проверка центрального заголовка на размер, если не помещается, то уменьшаем шрифт ==============================================================================================*/
    } else {
        var centerCaprion = $('.addition_center_caption_title'),
            centerCaprionText = $('.addition_center_caption_text');
        centerCaprion.removeAttr('style');
        centerCaprionText.removeAttr('style');
    }
});
$(window).on('load scroll resize', function () {
    blockVisible();

    /* Параллакс ==============================================================================================*/
    if (window.innerWidth > 1365) {
        var parallaxEl = $('.addition_motorrad_parallax_img'),
            windowScroll = $(this).scrollTop();
        if (parallaxEl.length != 0) {
            parallaxEl.each(function () {
                var parallaxEl = $(this),
                    parallaxParent = parallaxEl.parents('.addition_motorrad_parallax'),
                    parallaxParentH = parallaxParent.height(),
                    parallaxParentTop = parallaxParent.offset().top,
                    windowH = $(window).height(),
                    calcVisible = windowScroll + windowH,
                    parallax = windowScroll - parallaxParentTop,
                    parallaxParentBottom = parallaxParentTop + parallaxParentH;
                if (calcVisible >= parallaxParentTop) {
                    parallaxEl.css({
                        'transform': 'translate(0px, ' + parallax / 2 + 'px)',
                    });
                    if (windowScroll < parallaxParentBottom) {
                        parallaxParent.css({
                            'height': windowH - ((calcVisible - parallaxParentTop) / 3)
                        });
                    } else if (windowScroll >= parallaxParentBottom) {
                        parallaxParent.css({
                            'height': windowH - ((calcVisible - parallaxParentTop) / 3)
                        });
                        parallaxParent.css({
                            'height': parallaxParent.height()
                        })
                    }
                } else {
                    parallaxEl.removeAttr('style');
                    parallaxParent.removeAttr('style');
                }
            })
        }
    } else {
        // console.log(0);
        var parallaxEl = $('.addition_motorrad_parallax_img');
        parallaxEl.each(function () {
            parallaxEl = $(this),
                parallaxParent = parallaxEl.parents('.addition_motorrad_parallax');
            parallaxEl.removeAttr('style');
            parallaxParent.removeAttr('style');
        })
    }
    /* END Параллакс ==============================================================================================*/
})
/* Спойлеры (аккордеон) с проверкой на наличие внутри слайдера Slick ==============================================================================================*/
$(document).on('click', '.spoiler_toggler', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var spoiler = $(this),
        spoilerGrandParent = spoiler.parents('.addition_motorrad_spoilers_slides_collection'),
        spoilerParent = spoiler.parents('.spoiler__holder'),
        spoilerBody = spoilerParent.find('.spoiler_body'),
        duration = 300,
        slickTabs = spoilerBody.find('.addition_motorrad_text_with_photo_collection');
    if (!spoiler.hasClass('active')) {
        if (spoilerGrandParent.length != 0) {
            spoilerGrandParent.find('.spoiler_toggler').removeClass('active');
            spoilerGrandParent.find('.spoiler__holder').removeClass('active');
            spoilerGrandParent.find('.spoiler_body').removeClass('active').stop().slideUp(200);
        }
        spoiler.addClass('active');
        spoilerParent.addClass('active');
        spoilerBody.addClass('active').stop().slideDown(duration);
        if (slickTabs.length != 0 && slickTabs.children().length > 1 && !slickTabs.hasClass('slick-slider')) {
            slickTabs.on('init reInit afterChange', function (event, slick) {
                var slider = $(this),
                    sliderCounter = slider.parents('.addition_motorrad_text_with_photo_holder').find('.slider__counter');
                if (sliderCounter.length != 0) {
                    sliderCounter.text(parseInt(slick.currentSlide + 1) + ' / ' + slick.slideCount);
                }
            })
            slickTabs.slick({
                dots: false,
                infinite: false,
            })
        }
    } else {
        spoiler.removeClass('active');
        spoilerParent.removeClass('active');
        spoilerBody.removeClass('active').stop().slideUp(duration);
    }
});
/* END Спойлеры (аккордеон) с проверкой на наличие внутри слайдера Slick ==============================================================================================*/

/* Клик на стрелочку якоря(ВНИЗ). Проверка на его наличие описана выше (additionNext.length != 0) ==============================================================================================*/
$(document).on('click', '.anchor_to_bottom_addition', function () {
    var anchorParent = $(this).parents('.addition_data'),
        anchorNext = anchorParent.next('.addition_data'),
        headerH = $('.header').height();
    if (anchorNext.length != 0) {
        anchorNextTop = anchorNext.offset().top;
        $('body, html').animate({ scrollTop: anchorNextTop - headerH }, 1000);
        return false;
    }
});
/* END Клик на стрелочку якоря(ВНИЗ). Проверка на его наличие описана выше (additionNext.length != 0) ==============================================================================================*/

/* Эмуляция клика на кнопку lightcase активного слайдера ==============================================================================================*/
$(document).on('click', '.addition_motorrad_slider_btn_lightcase', function () {
    var btn = $(this),
        btnParent = btn.parents('.slider__holder'),
        btnParentSlide = btnParent.find('.slick-current');
    if (btnParentSlide.length != 0) {
        btnLightcase = btnParentSlide.find('.addition_motorrad_slide_img_lightcase');
    } else {
        btnLightcase = btnParent.find('.addition_motorrad_slide_img_lightcase');
    }
    btnLightcase.click();
})
/* END Эмуляция клика на кнопку lightcase активного слайдера ==============================================================================================*/

/* Табы с проверкой на наличие внутри слайдера Slick ==============================================================================================*/
$(document).on('click', '.addition_motorrad_tabs_toggler', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var el = $(this),
        target = el.attr('data-target'),
        parent = el.parents('.addition_motorrad_tabs'),
        elAll = parent.find('.addition_motorrad_tabs_toggler'),
        content = parent.find('[data-content="' + target + '"]'),
        contentAll = parent.find('[data-content]'),
        slickTabs = parent.find('[data-content="' + target + '"]').find('.addition_motorrad_text_with_photo_collection');
    elAll.removeClass('active');
    el.addClass('active');
    contentAll.removeClass('active');
    content.addClass('active');
    if (slickTabs.length != 0 && slickTabs.children().length > 1 && !slickTabs.hasClass('slick-slider')) {
        slickTabs.on('init reInit afterChange', function (event, slick) {
            var slider = $(this),
                sliderCounter = slider.parents('.addition_motorrad_text_with_photo_holder').find('.slider__counter');
            if (sliderCounter.length != 0) {
                sliderCounter.text(parseInt(slick.currentSlide + 1) + ' / ' + slick.slideCount);
            }
        })
        slickTabs.slick({
            dots: false,
            infinite: false,
        })
    }
});
/* END Табы с проверкой на наличие внутри слайдера Slick ==============================================================================================*/


/************************************
    More additions for main page. We need more additions!!!!
************************************/

$(document).on('click', '.more_additions', function (e) {
    e.preventDefault();
    e.preventDefault();
    var el = $(this);
    var parent = el.closest('.tabs__content');
    var skip = el.attr('data-skip');
    var id = el.attr('data-id');
    $.post('service/more-additions', { 'skip': skip, 'id': id }, function (data) {
        el.parents('.btn__holder').remove();
        parent.append(data);
        wallWidth();
        blockVisible();
    });
});

/*= Распределение 12 юнитов на главной странице по ширине =============================================================================================*/
$(document).ready(function () {
    wallWidth();

    $(window).on('resize', function () {
        wallWidth();
    })
})

function wallWidth() {
    if (window.innerWidth > 1365) {
        $('.wall__item.wall__item--click:nth-child(-n+2), .wall__item.wall__item--click:nth-child(8), .wall__item.wall__item--click:nth-child(n+10):nth-child(-n+11)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+3):nth-child(-n+7), .wall__item.wall__item--click:nth-child(9)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--25');
        $('.wall__item.wall__item--click:nth-child(12)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');

        $('.wall__item.wall__item--click:nth-child(n+13):nth-child(-n+14), .wall__item.wall__item--click:nth-child(20), .wall__item.wall__item--click:nth-child(n+22):nth-child(-n+23)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+15):nth-child(-n+19), .wall__item.wall__item--click:nth-child(21)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--25');
        $('.wall__item.wall__item--click:nth-child(24)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');

        $('.wall__item.wall__item--click:nth-child(n+25):nth-child(-n+26), .wall__item.wall__item--click:nth-child(32), .wall__item.wall__item--click:nth-child(n+34):nth-child(-n+35)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+27):nth-child(-n+31), .wall__item.wall__item--click:nth-child(33)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--25');
        $('.wall__item.wall__item--click:nth-child(36)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
    } else if (window.innerWidth > 1023) {
        $('.wall__item.wall__item--click:nth-child(-n+2), .wall__item.wall__item--click:nth-child(8), .wall__item.wall__item--click:nth-child(n+10):nth-child(-n+11)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+3):nth-child(-n+7), .wall__item.wall__item--click:nth-child(9)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(12)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');

        $('.wall__item.wall__item--click:nth-child(n+13):nth-child(-n+14), .wall__item.wall__item--click:nth-child(20), .wall__item.wall__item--click:nth-child(n+22):nth-child(-n+23)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+15):nth-child(-n+19), .wall__item.wall__item--click:nth-child(21)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(24)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');

        $('.wall__item.wall__item--click:nth-child(n+25):nth-child(-n+26), .wall__item.wall__item--click:nth-child(32), .wall__item.wall__item--click:nth-child(n+34):nth-child(-n+35)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+27):nth-child(-n+31), .wall__item.wall__item--click:nth-child(33)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(36)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
    } else {
        $('.wall__item.wall__item--click:nth-child(-n+2), .wall__item.wall__item--click:nth-child(8), .wall__item.wall__item--click:nth-child(n+10):nth-child(-n+11)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
        $('.wall__item.wall__item--click:nth-child(n+3):nth-child(-n+7), .wall__item.wall__item--click:nth-child(9)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
        $('.wall__item.wall__item--click:nth-child(12)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');

        $('.wall__item.wall__item--click:nth-child(n+13):nth-child(-n+14), .wall__item.wall__item--click:nth-child(20), .wall__item.wall__item--click:nth-child(n+22):nth-child(-n+23)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+15):nth-child(-n+19), .wall__item.wall__item--click:nth-child(21)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
        $('.wall__item.wall__item--click:nth-child(24)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');

        $('.wall__item.wall__item--click:nth-child(n+25):nth-child(-n+26), .wall__item.wall__item--click:nth-child(32), .wall__item.wall__item--click:nth-child(n+34):nth-child(-n+35)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--50');
        $('.wall__item.wall__item--click:nth-child(n+27):nth-child(-n+31), .wall__item.wall__item--click:nth-child(33)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
        $('.wall__item.wall__item--click:nth-child(36)').removeClass('wall__item--25 wall__item--50 wall__item--100').addClass('wall__item--100');
    }
}
/*= END Распределение 12 юнитов на главной странице по ширине =============================================================================================*/

function blockVisible() {
    /* Проверка всех блоков на появление на странице (сразу или снизу страницы) если появился - то делаем анимацию в css ==============================================================================================*/
    var el = $('.when__visible'),
        windowScroll = $(this).scrollTop(),
        windowH = $(window).height(),
        calcVisible = windowScroll + windowH;
    if (el.length != 0) {
        el.each(function () {
            $el = $(this),
                addition = $el.parents('.addition_motorrad_tabs'),
                $elTop = $el.offset().top;
            if (calcVisible >= $elTop && addition.length == 0) {
                $el.addClass('active');
            } else {
                $el.removeClass('active');
            }
        })
    }
    /* END Проверка всех блоков на появление на странице (сразу или снизу страницы) если появился - то делаем анимацию в css ==============================================================================================*/
}


$(document).ready(function () {
    function handleVideoPlayback(entries, observer) {
        entries.forEach(entry => {
            let video = entry.target;

            if (entry.isIntersecting) {
                if (video.readyState >= 3) { // Проверяем, готово ли видео
                    video.play().catch(error => {
                        console.warn("Ошибка автозапуска видео:", error);
                    });
                }
            } else {
                video.pause();
            }
        });
    }

    let observerOptions = {
        root: null,
        threshold: 0.5
    };

    let observer = new IntersectionObserver(handleVideoPlayback, observerOptions);

    $('.js__video_solo video').each(function () {
        const video = this;
        video.setAttribute('playsinline', ''); // Для мобильных устройств
        video.muted = true;                   // Мьютим видео сразу

        // Добавляем обработчик для ошибок
        video.addEventListener('error', () => {
            console.error("Ошибка при загрузке видео:", video.src);
        });

        // Обрабатываем событие canplay
        video.addEventListener('canplay', () => {
            observer.observe(video);
        });

        // Если видео уже готово, начинаем наблюдение
        if (video.readyState >= 3) {
            observer.observe(video);
        }
    });

    // Обработка клика для запуска видео
    $('.js__video_solo video').on('click', function () {
        if (this.paused) {
            this.play().catch(error => {
                console.warn("Ошибка воспроизведения при нажатии:", error);
            });
        } else {
            this.pause();
        }
    });
});


